import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormService } from '../../services/form.service';
import currencies from '../../../assets/json/currencies-by-country-en.json';

@Component( {
	selector: 'app-currency-exchange',
	templateUrl: './currency-exchange.component.html',
	styleUrls: ['./currency-exchange.component.scss']
} )
export class CurrencyExchangeComponent implements OnInit {
	public formGroupName: string = 'currency_exchange';
	public currencyExchangeForm!: UntypedFormGroup;

	public currencies: any[] = currencies;
	public uniqueCurrencies: any[] = [];

	constructor( public formService: FormService ) {}

	ngOnInit(): void {
		this.currencyExchangeForm = this.formService.thirdPartyForm.get( this.formGroupName ) as UntypedFormGroup;

		// Filter unique currencies by currencyCode
		const seen = new Set();
		this.uniqueCurrencies = this.currencies.filter( currency => {
			if( seen.has( currency.currencyCode ) ) {
				return false;
			}
			seen.add( currency.currencyCode );
			return true;
		} );

		// Get country codes from main form and verify them
		const countryFrom = this.formService.verifyCountryCode( this.formService.mainForm.get('movingFrom')?.get('country')?.value );
		const countryTo = this.formService.verifyCountryCode( this.formService.mainForm.get('movingTo')?.get('country')?.value );

		// Find currencies for the countries
		const fromCurrency = this.currencies.find(currency => currency.countryCode === countryFrom);
		const toCurrency = this.currencies.find(currency => currency.countryCode === countryTo);

		console.log( fromCurrency );
		console.log( toCurrency );

		// Set default values if not already set
		if ( !this.currencyExchangeForm.get('fromCurrency')?.value ) {
			this.currencyExchangeForm.get('fromCurrency')?.setValue(fromCurrency?.currencyCode);
		}

		if ( !this.currencyExchangeForm.get('toCurrency')?.value ) {
			this.currencyExchangeForm.get('toCurrency')?.setValue(toCurrency?.currencyCode);
		}
	}

	onSubmit(): void {
		this.formService.submitThirdPartyFormGroup( this.currencyExchangeForm );
	}
}
